import { render, staticRenderFns } from "./AccountContactsTab.vue?vue&type=template&id=03c4313e&scoped=true&"
import script from "./AccountContactsTab.vue?vue&type=script&lang=js&"
export * from "./AccountContactsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c4313e",
  null
  
)

export default component.exports